import { render, staticRenderFns } from "./supply-currency-input.vue?vue&type=template&id=5b53e448"
import script from "./supply-currency-input.vue?vue&type=script&lang=js"
export * from "./supply-currency-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports